import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import { MapPin, Store } from "lucide-react";
import bergenBg from "../../assets/bergen.webp";
import { LanguageContext } from "../../context/LanguageContext";
import no from "../../context/no";
import en from "../../context/en";

function FindUs() {
  const { language } = useContext(LanguageContext);
  const translations = language === "en" ? en.home.findUs : no.home.findUs;
  const buttonTranslations =
    language === "en" ? en.home.button : no.home.button;

  const place = "Steinkjellergaten+2+5003+Bergen";

  return (
    <section
      className="relative min-h-screen h-fit flex items-center bg-cover bg-center"
      style={{ backgroundImage: `url(${bergenBg})` }}
      id="findUs"
    >
      <div className="absolute inset-0 bg-black/85" />
      <div className="container relative z-10">
        <div className="wrap">
          <div className="mx-auto flex items-center w-fit h-10 my-16">
            <div className="vertical-line gradient-vertical"></div>
            <h1 className="text-main-light text-2xl md:text-[2.5rem] font-extrabold">
              {translations.title}
            </h1>
          </div>

          <div className="mx-auto grid max-w-[1200px] grid-cols-1 items-stretch gap-8 pb-16 md:grid-cols-2 md:gap-4 [&>*]:h-full">
            <Fade
              direction="up"
              triggerOnce
              className="!flex h-full"
              style={{ display: "flex", height: "100%" }}
            >
              <div className="flex h-full w-full flex-col bg-main-light p-8 text-center">
                <div className="flex flex-col items-center gap-3">
                  <MapPin
                    className="mb-1 h-7 w-7 text-main-dark"
                    color="#000000"
                    strokeWidth={1.5}
                    aria-hidden="true"
                  />
                  <h4 className="font-heading font-bold !text-main-dark">
                    Bergen
                  </h4>
                  <p className="text-main-dark">
                    Steinkjellergaten 2, 5003 Bergen
                  </p>
                  <div className="space-y-0.5">
                    <p className="text-main-dark">{translations.wednesday}</p>
                    <p className="text-main-dark">{translations.thursday}</p>
                    <p className="text-main-dark">{translations.saturday}</p>
                    <p className="mt-4 text-main-dark">
                      {translations.alwaysBook}
                    </p>
                  </div>
                </div>
                <div className="mt-auto flex w-full flex-col gap-4 pt-8 md:flex-row md:items-center">
                  <button
                    type="button"
                    className="cta cta-dark w-full whitespace-nowrap md:flex-1"
                    onClick={() =>
                      window.open(
                        `https://www.google.com/maps/search/?api=1&query=${place}`
                      )
                    }
                  >
                    {buttonTranslations.openMap}
                  </button>
                  <a
                    href="https://instantiris.onlinebooq.net/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cta gradient w-full whitespace-nowrap text-center md:flex-1"
                  >
                    {buttonTranslations.book}
                  </a>
                </div>
              </div>
            </Fade>

            <Fade
              direction="up"
              delay={100}
              triggerOnce
              className="!flex h-full"
              style={{ display: "flex", height: "100%" }}
            >
              <div className="flex h-full w-full flex-col bg-main-light p-8 text-center">
                <div className="flex flex-col items-center gap-3">
                  <Store
                    className="mb-1 h-7 w-7 text-main-dark"
                    color="#000000"
                    strokeWidth={1.5}
                    aria-hidden="true"
                  />
                  <h4 className="font-heading font-bold !text-main-dark">
                    {translations.partnership.title}
                  </h4>
                  <p className="text-main-dark">
                    {translations.partnership.text}
                  </p>
                </div>
                <div className="mt-auto w-full pt-8">
                  <Link
                    to="/contact"
                    className="cta gradient block w-full whitespace-nowrap text-center"
                  >
                    {buttonTranslations.contactUs}
                  </Link>
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FindUs;
